jQuery(document).ready(function($) {   

    let coinTableContainers = document.querySelectorAll('.ctp-coin-table-container');  

    // if there are some tables on the page
    if (coinTableContainers.length > 0) { 

        coinTableContainers.forEach(function(container) { 

            let dataLimit         = container.dataset.limit; // number of rows per page of a table
            let dataCategory      = container.dataset.category;
            let containerId       = container.id;  
            let selectFiat        = container.querySelector('.ctp-select-currency');
            let selectedFiatValue = selectFiat.options[selectFiat.selectedIndex].value;

            
            // relocating currency drop down if needed       
            let targetCurrencyContainer = container.querySelector('.ctp-coin-currency.ctp-mobile');
            let originalCurrencyContainer = container.querySelector('.ctp-coin-currency.ctp-desktop');

            // console.log( selectFiat);

            if (window.innerWidth < 1200) {
                // Move the element to the mobile container if not already moved
                if (selectFiat && targetCurrencyContainer && !targetCurrencyContainer.contains(selectFiat)) {
                    targetCurrencyContainer.appendChild(selectFiat);
                }
            } else {
                // Move the element back to the original container if not already there
                if (selectFiat && originalCurrencyContainer && !originalCurrencyContainer.contains(selectFiat)) {
                    originalCurrencyContainer.appendChild(selectFiat);
                }
            }

            // initial - populate table
            // setTimeout(() => {
            //     ctpFillTable(container, dataLimit, 1, selectedFiatValue);  
            //     console.log("Executed after 2000m delay");

            // }, 2000);
            ctpFillTable(container, dataLimit, 1, selectedFiatValue, dataCategory);    
            
         
            /**
             * Funtion to change the number of rows
             */

            let selectPerPage = container.querySelectorAll('.ctp-select-per-page');

            // console.log( selectPerPage );

            if( selectPerPage.length > 0 ) {   
                
                selectPerPage.forEach(function(select) {
                    select.addEventListener('change', function() {  
                        
                        // change the other if there is 
                        document.querySelectorAll('.ctp-select-per-page').forEach(otherSelect => {
                            if (otherSelect !== this) {
                                otherSelect.value = this.value;
                            }
                        });
                    
                        let dataCoins           = container.dataset.coins; // total number of coins 
                        let selectedValue       = $(this).val();               
                        let newNumberPages      = Math.ceil(dataCoins/selectedValue);  
                        let selectCFiat         = container.querySelector('.ctp-select-currency');
                        let selectedCFiatValue  = selectCFiat.options[selectFiat.selectedIndex].value;    
                        container.dataset.total = newNumberPages;
                        let searchField         = container.querySelector('.ctp-search-field');
                        let searchFieldValue    = searchField.value;
    
                        if( searchFieldValue !== '' ) {
                            ctpFillTableSearch(container, dataLimit, 1, searchFieldValue, selectedFiatValue, dataCategory);
                        } else {
                            ctpFillTable(container, selectedValue, 1, selectedCFiatValue, dataCategory);
                        }
                    });
                    
                }); 

                
            }  
            
            /**
             * Function to change fiat/crypto currency
             */    
            if( selectFiat ) {
                selectFiat.addEventListener( 'change', function() {

                    let selectedValue = $(this).val();   
                    ctpUpdatePrices( container, selectedValue );  
                });
            }

            /**
             * Pagination prev and next functionality - separate buttons
             */
            let prevButton = container.querySelector('.ctp-nav.ctp-arr-prev'); // left arrow
            let nextButton = container.querySelector('.ctp-nav.ctp-arr-next'); // right arrow
            let navPages   = container.querySelectorAll('.ctp-pagination-wrapper .ctp-nav');

            

            if( prevButton && nextButton ) {

                $(prevButton).on('click', function(e) {
                    e.preventDefault();

                    console.log( prevButton );
    
                    let dataLimit         = container.dataset.limit; // number of rows per page of a table
                    let dataCurrentPage   = container.dataset.current; // current page
                    let prevPage          = parseInt(dataCurrentPage) - 1;      
                    let selectFiat        = container.querySelector('.ctp-select-currency');
                    let selectedFiatValue = selectFiat.options[selectFiat.selectedIndex].value;    
                    let searchField       = container.querySelector('.ctp-search-field');
                    let searchFieldValue  = searchField.value;
                    // console.log( searchFieldValue );                    
                   
                    if( dataCurrentPage == 1 ) { return; }    
    
                    if (prevPage >= 1) {  
                        container.dataset.current = prevPage;                          
                        
                        if( searchFieldValue !== '' ) {
                            ctpFillTableSearch(container, dataLimit, prevPage, searchFieldValue, selectedFiatValue, dataCategory);
                        } else {
                            ctpFillTable(container, dataLimit, prevPage, selectedFiatValue, dataCategory); 
                        }

                        // Remove 'active' class from all navigation items
                        navPages.forEach(function(navItem) {
                            navItem.classList.remove('ctp-nav-active');
                        });      

                    } else {
                        console.log('No more pages to load.');
                    }        
                  
                    // Disable prev button if on the first page
                    if (prevPage == 1) {
                        $(prevButton).addClass('disabled');
                        $(nextButton).removeClass('disabled');
                    } else {
                        $(prevButton).removeClass('disabled');
                        $(nextButton).removeClass('disabled');                                             
                    }

                    const currentPage = parseInt(paginationWrapper.querySelector('.ctp-nav-active').getAttribute('data-value'));
                    if (currentPage > 1) {
                        updatePagination(currentPage - 1);
                        let dataLimit = container.dataset.limit; 

                        if( searchFieldValue !== '' ) {
                            ctpFillTableSearch(container, dataLimit, currentPage - 1, searchFieldValue, selectedFiatValue, dataCategory);
                        } else {
                            ctpFillTable(container, dataLimit, currentPage - 1, selectedFiatValue, dataCategory); 
                        }                
                    }
                });
    
                $(nextButton).on('click', function(e) {
                    e.preventDefault();
    
                    let dataLimit         = container.dataset.limit; // number of rows per page of a table
                    let dataTotalPages    = container.dataset.total; // total of pages
                    let dataCurrentPage   = container.dataset.current; // current page  
                    let nextPage          = parseInt(dataCurrentPage) + 1;  
                    let selectFiat        = container.querySelector('.ctp-select-currency');
                    let selectedFiatValue = selectFiat.options[selectFiat.selectedIndex].value;
                    let searchField       = container.querySelector('.ctp-search-field');
                    let searchFieldValue  = searchField.value;
                    // console.log( searchFieldValue );  

                    if( dataCurrentPage == dataTotalPages ) { return; }                                  
    
                    if (nextPage <= dataTotalPages) {  
    
                        container.dataset.current = nextPage; 

                        if( searchFieldValue !== '' ) {
                            ctpFillTableSearch(container, dataLimit, nextPage, searchFieldValue, selectedFiatValue, dataCategory);
                        } else {
                            ctpFillTable(container, dataLimit, nextPage, selectedFiatValue, dataCategory); 
                        }                       
                                               

                    } else {
                        console.log('No more pages to load.');
                    }                    
    
                    // Disable next button if on the last page
                    if (nextPage == dataTotalPages ) {
                        $(nextButton).addClass('disabled');
                        $(prevButton).removeClass('disabled');
                    } else {
                        $(nextButton).removeClass('disabled');
                        $(prevButton).removeClass('disabled');
                    }

                    const currentPage = parseInt(paginationWrapper.querySelector('.ctp-nav-active').getAttribute('data-value'));
                    if (currentPage < totalPages) {
                        updatePagination(currentPage + 1);                    
                        let dataLimit = container.dataset.limit; // number of rows per page of a table

                        if( searchFieldValue !== '' ) {
                            ctpFillTableSearch(container, dataLimit, currentPage + 1, searchFieldValue, selectedFiatValue, dataCategory);
                        } else {
                            ctpFillTable(container, dataLimit, currentPage + 1, selectedFiatValue, dataCategory); 
                        }              
                    }
                });                
            } 
        

            /**
             * Pagination 
             */            
            const pagination        = container.querySelector('.ctp-number-pagination');
            const paginationWrapper = pagination.querySelector('.ctp-pagination-wrapper');
            const navPages1         = paginationWrapper.querySelectorAll('.ctp-nav[data-value]');
            const prevButton1       = paginationWrapper.querySelector('.ctp-arr-prev');
            const nextButton1       = paginationWrapper.querySelector('.ctp-arr-next');
            const totalPages        = parseInt(paginationWrapper.querySelector('.ctp-nav-last').getAttribute('data-value'));       
            const navFrom           = container.querySelector('.ctp-nav-from');
            const navTo             = container.querySelector('.ctp-nav-to');
            const filters           = container.querySelector('.ctp-filters-wrapper');            
            let tableHolder         = container.querySelector('.ctp-coin-table-body');
            let holderWidth         = tableHolder.offsetWidth;

            if( pagination ) {
                // pagination.style.width  = holderWidth + 'px';
            }   
            
            if( filters ) {
                // filters.style.width = holderWidth + 'px';
            }
            
            function updatePagination(currentPage) { 
                
                let tableLimit  = parseInt(container.dataset.limit);  
                let totalPages1 = parseInt(container.dataset.total);                         
                let limitFrom   = (tableLimit * (currentPage - 1)) + 1;
                let limitTo     = limitFrom + tableLimit - 1;  
                let pagination        = container.querySelector('.ctp-number-pagination');
                let paginationWrapper = pagination.querySelector('.ctp-pagination-wrapper');
                navFrom.textContent = limitFrom;
                navTo .textContent  = limitTo;

                paginationWrapper.innerHTML = '';
                // console.log('pag  ' + totalPages1);
        
                // Add prev button
                paginationWrapper.appendChild(prevButton1);
        
                if (currentPage > 2) { createNavButton(1); }        
                if (currentPage > 3) { createDot(); }        
                if (currentPage > 1) { createNavButton(currentPage - 1); }        
                createNavButton(currentPage, true);
        
                if (currentPage < totalPages1) { createNavButton(currentPage + 1); }        
                if (currentPage < totalPages1 - 2) { createDot(); }        
                if (currentPage < totalPages1 - 1) { createNavButton(totalPages1); }
        
                // Add next button
                paginationWrapper.appendChild(nextButton1);
        
                // Enable/disable prev/next buttons
                prevButton1.classList.toggle('disabled', currentPage === 1);
                nextButton1.classList.toggle('disabled', currentPage === totalPages1);
        
                // Update event listeners for navigation buttons
                paginationWrapper.querySelectorAll('.ctp-nav[data-value]').forEach(nav => {
                    nav.addEventListener('click', function(e) {
                        e.preventDefault();
                        let newPage           = parseInt(this.getAttribute('data-value'));
                        let selectFiat        = container.querySelector('.ctp-select-currency');
                        let selectedFiatValue = selectFiat.options[selectFiat.selectedIndex].value;
                        let searchField       = container.querySelector('.ctp-search-field');
                        let searchFieldValue  = searchField.value;
    
                        if( searchFieldValue !== '' ) {
                            ctpFillTableSearch(container, tableLimit, newPage, searchFieldValue, selectedFiatValue, dataCategory);
                        } else {
                            ctpFillTable(container, tableLimit, newPage, selectedFiatValue, dataCategory); 
                        }                        
                        updatePagination(newPage);
                    });
                });
            }
        
            function createNavButton(page, isActive = false) {
                let pagination        = container.querySelector('.ctp-number-pagination');
                let paginationWrapper = pagination.querySelector('.ctp-pagination-wrapper');
                const navButton = document.createElement('span');
                navButton.classList.add('ctp-nav');
                navButton.setAttribute('data-value', page);
                navButton.textContent = page;
                if (isActive) {
                    navButton.classList.add('ctp-nav-active');
                }
                paginationWrapper.appendChild(navButton);
            }
        
            function createDot() {
                let pagination        = container.querySelector('.ctp-number-pagination');
                let paginationWrapper = pagination.querySelector('.ctp-pagination-wrapper');
                const dot = document.createElement('span');
                dot.classList.add('ctp-nav', 'ctp-dot');
                dot.textContent = '...';
                paginationWrapper.appendChild(dot);
            }
        
            // Initial pagination setup
            updatePagination(1);            

            //Update prices according to chosen one in drop down            
            function ctpUpdatePrices( container, selectedValue ) {

                let prices        = container.querySelectorAll('.ctp-coin-table-body .ctp-coin-price');
                let mc            = container.querySelectorAll('.ctp-coin-table-body .ctp-coin-mc');
                let volume        = container.querySelectorAll('.ctp-coin-table-body .ctp-coin-volume');
                let low           = container.querySelectorAll('.ctp-coin-table-body .ctp-low');      
                let high          = container.querySelectorAll('.ctp-coin-table-body .ctp-high');      
                // console.log( prices, mc, volume, selectedValue);     

                // if selected currency is fiat
                if( selectedValue == 'EUR' || selectedValue == 'GBP' || selectedValue == 'USD' ) {
                    if( prices && prices.length > 0 ) { ctpUpdateFiatPrices(prices, selectedValue); }
                    if( mc && mc.length > 0 ) { ctpUpdateFiatPrices(mc, selectedValue); }
                    if( volume && volume.length > 0 ) { ctpUpdateFiatPrices(volume, selectedValue); }
                    if( low && low.length > 0 ) { ctpUpdateFiatPrices(low, selectedValue); }
                    if( high && high.length > 0 ) { ctpUpdateFiatPrices(high, selectedValue); }
                }
                // if selected currency is crypto
                if( selectedValue == 'BTC' || selectedValue == 'ETH' ) {
                    if( prices && prices.length > 0 ) { ctpUpdateCryptoPrices(prices, selectedValue); }
                    if( mc && mc.length > 0 ) { ctpUpdateCryptoPrices(mc, selectedValue); }
                    if( volume && volume.length > 0 ) { ctpUpdateCryptoPrices(volume, selectedValue); }
                    if( low && low.length > 0 ) { ctpUpdateCryptoPrices(low, selectedValue); }
                    if( high && high.length > 0 ) { ctpUpdateCryptoPrices(high, selectedValue); }
                }
            } 


            //Function to update each cell of the table    
            function ctpUpdateTable(container, coins, limit, page) {  

                if( container && coins && limit && page ) {

                    let ctpCoinTable       = container.querySelector('.ctp-coin-table-body .ctp-coin-table-frame'); // rows holder
                    let ctpCoinTableRows   = ctpCoinTable.querySelectorAll('.ctp-coin-table-row'); // array of rows
                    ctpCoinTable.innerHTML = ''; // clean table
                    let addedRows          = ctpAddRows(container, coins.length); // adding html for rows 
                    let containerId        = container.id;
                    let newTable           = document.getElementById(containerId);
                    ctpCoinTable           = newTable.querySelector('.ctp-coin-table-body .ctp-coin-table-frame'); // new table, cleaned
                    ctpCoinTableRows       = ctpCoinTable.querySelectorAll('.ctp-coin-table-row'); // array of rows  
                    container.dataset.current = page; // update page
                    container.dataset.limit   = limit; // update limit    

                    if( ctpCoinTable ) {   
                        
                        // console.log( coins );
                    
                        for (let i = 0; i < coins.length ; i++) {                    
                            
                            let row = ctpCoinTableRows[i]; 
                            if( undefined == coins[i] ) {
                                console.log( 'no coin' );
                            }
            
                            // rank
                            let rank         = row.querySelector('.ctp-coin-rank');
                            rank.textContent = coins[i].rank;
                            if( rank.classList.contains( 'ctp-line-skeleton' ) ) {
                                rank.classList.remove( 'ctp-line-skeleton' );
                            }
            
                            // name
                            let name     = row.querySelector('.ctp-coin-name');
                            let nameCell = row.querySelector('.ctp-ct-name');
                            nameCell.textContent = coins[i].name;
            
                            // icon
                            let icon       = row.querySelector('.ctp-coin-icon');
                            icon.innerHTML = '';

                            if (undefined != coins[i].icon) {
                                let urlIcon = 'https://cryptify-platform-dev.clickoutmedia.tech' + coins[i].icon;
                            
                                fetch(urlIcon)
                                    .then(response => {
                                        if (response.ok) {
                                            let img = $('<img>').attr('src', urlIcon).attr('alt', coins[i].name);
                                            icon.append(img[0]);
                                        } else {
                                            let img = $('<div>').addClass('ctp-grey-circle');
                                            icon.append(img[0]);
                                        }
                                    })
                                    .catch(error => {
                                        let img = $('<div>').addClass('ctp-grey-circle');
                                        icon.append(img[0]);
                                    });
                            } else {
                                let img = $('<div>').addClass('ctp-grey-circle');
                                icon.append(img[0]);
                            }                            
            
                            if (name.classList.contains('ctp-line-skeleton')) {
                                name.classList.remove('ctp-line-skeleton');
                            }
            
                            // symbol
                            let symbol = row.querySelector('.ctp-ct-symbol');
                            symbol.textContent = coins[i].symbol;

                            // buy coin
                            let buyCoin     = row.querySelector('.ctp-coin-buy');
                            let wrapperCoin = row.querySelector('.ctp-name-wrapper');

                            buyCoin.dataset.coinId = coins[i]._id; // platform_id  

                            // console.log( buyCoin.dataset );

                            // if( buyCoin.innerHTML != '' ) {
                            //     wrapperCoin.style.width = '130px';
                            // }                           
            
                            // price
                            let price = row.querySelector('.ctp-coin-price');
                            let rawPrice = coins[i].price;
                            let formattedPrice = formatSmallPriceDollar(rawPrice);
                            // console.log( coins[i].price, formattedPrice, coins[i].name);
                            price.setAttribute('data-number', coins[i].price );
                            price.textContent = formattedPrice;

                            if (price.classList.contains('ctp-line-skeleton')) {
                                price.classList.remove('ctp-line-skeleton');
                            }
            
                            // graph
                            let graphCell = row.querySelector('.ctp-coin-last');
                            let graphBase = 'https://cryptify-platform-dev.clickoutmedia.tech/api/svg/';
                            let graphTail = '?time=7d';
                            let graphUrl  = graphBase + coins[i]._id + graphTail;

                            // console.log( ctpAjax.pluginUrl );
            
                            fetch(graphUrl)
                            .then(response => {                     
                                return response.text();
                            })                   
                            .then(data => {

                                if (data.startsWith('{"message')) {
                                    const noGraph = document.createElement('img');
                                    noGraph.src = ctpAjax.pluginUrl + 'assets/img/no-graph.png';
                                    noGraph.alt = 'Not Available';
                                    graphCell.appendChild(noGraph);                                

                                    if (graphCell.classList.contains('ctp-line-skeleton')) {
                                        graphCell.classList.remove('ctp-line-skeleton');
                                    }
                                } else {
                
                                    graphCell.innerHTML = data;  
                                    let svg = graphCell.querySelector( 'svg' );    

                                    let change7d = parseFloat(coins[i].change7d);
                                    
                        
                                    if (change7d > 0) {
                                        graphCell.classList.remove('negative');
                                        graphCell.classList.add('positive');
                                    } else {
                                        graphCell.classList.remove('positive');
                                        graphCell.classList.add('negative');
                                    }

                                    // console.log( change7d, coins[i].name, graphCell.classList);

                                    if( graphCell.classList.contains('positive') ) {
                                        ctpModifySvg(svg, true);
                                    }else{
                                        ctpModifySvg(svg, false);
                                    }
                        
                                    if (graphCell.classList.contains('ctp-line-skeleton')) {
                                        graphCell.classList.remove('ctp-line-skeleton');
                                    }
                                }                   
                            })
                            .catch(error => console.error('Error fetching SVG:', error));
            
                            // change 24h
                            let change             = row.querySelector('.ctp-coin-change');
                            let changeCell         = row.querySelector('.ctp-coin-change-abs');
                            let changeFormated     = formatAsPercentageAbs(coins[i].change24h);
                            let change24h          = coins[i].change24h;
                            changeCell.textContent = changeFormated;
                            
                            if( change24h > 0 ) {
                                change.classList.add( 'positive' );
                                change.classList.remove( 'negative' );
                            } else {
                                change.classList.add( 'negative' );
                                change.classList.remove( 'positive' );
                            }
                            if( change.classList.contains( 'ctp-line-skeleton' ) ) {
                                change.classList.remove( 'ctp-line-skeleton' );
                            }
            
                            // market cap
                            let marketCap          = row.querySelector('.ctp-coin-mc');
                            let rawMarketCap       = coins[i].marketCap;
                            let formattedMarketCap = formatAsDollarsZeroD(rawMarketCap);
                            marketCap.setAttribute('data-number', rawMarketCap);
                            marketCap.textContent  = '$' + formattedMarketCap;

                            if (marketCap.classList.contains('ctp-line-skeleton')) {
                                marketCap.classList.remove('ctp-line-skeleton');
                            }
            
                            // volume 24h
                            let volume          = row.querySelector('.ctp-coin-volume');
                            let rawVolume       = coins[i].volume24h;
                            let formattedVolume = formatAsDollarsZeroD(rawVolume);
                            // console.log( formattedVolume);
                            volume.setAttribute('data-number', rawVolume);
                            volume.textContent  = '$' + formattedVolume;
                            
                            if (volume.classList.contains('ctp-line-skeleton')) {
                                volume.classList.remove('ctp-line-skeleton');
                            }       
                            
                            // 52 weeks
                            let weeks        = row.querySelector('.ctp-coin-52-weeks');
                            let low          = row.querySelector('.ctp-coin-52-weeks .ctp-low');
                            let high         = row.querySelector('.ctp-coin-52-weeks .ctp-high');
                            let pinkSlider   = row.querySelector('.ctp-coin-52-weeks .ctp-pink-slider');
                            let purpleSlider = row.querySelector('.ctp-coin-52-weeks .ctp-purple-slider');
                            let rowLow       = coins[i].low52Week;
                            let rowHigh      = coins[i].high52Week;
                            
                            low.textContent  = formatSmallPriceDollar(rowLow);
                            low.setAttribute('data-number', rowLow);
                            high.textContent = formatSmallPriceDollar(rowHigh);
                            high.setAttribute('data-number', rowHigh);

                            if (weeks.classList.contains('ctp-line-skeleton')) {
                                weeks.classList.remove('ctp-line-skeleton');
                            }

                            let priceDiff    = parseFloat(rowHigh) - parseFloat(rowLow);
                            let currentDiff  = parseFloat(coins[i].price) - parseFloat(rowLow);
                            let rowPercentage = 100;

                            if ( priceDiff != 0 ) {
                                rowPercentage = (currentDiff / (priceDiff)) * 100;                            
                            } 
                            
                            // let roundPercentage = parseInt( rowPercentage );
                            // console.log( priceDiff,  coins[i].name );
                            pinkSlider.style.height = '2px';
                            pinkSlider.style.width = '100%';
                            purpleSlider.style.height = '2px';

                            if( rowPercentage >= 100 ) {
                                purpleSlider.style.width = '100%';                                
                            } else {
                                purpleSlider.style.width = rowPercentage + '%';
                            }
                            
                            
                        }                       
                    } 
                    
                    
                }               
            }

            //Get data via AJAX by PHP proxy function (in order to hide API key) 
            function ctpGetCoinsAjax(limit, page, category = '') {

                return new Promise((resolve, reject) => {

                    page  = parseInt(page);
                    limit = parseInt(limit);
            
                    let offset = (page - 1) * limit;
            
                    if (typeof ctpAjax === 'undefined' || typeof ctpAjax.ajax_url === 'undefined' || typeof ctpAjax.nonce === 'undefined') {
                        console.log('ctpAjax object or its properties are not defined.');
                        reject('ctpAjax object or its properties are not defined.');
                        return;
                    }
            
                    $.ajax({
                        url: ctpAjax.ajax_url,
                        type: 'POST',
                        data: {
                            action: 'ctp_ajax_action',
                            nonce: ctpAjax.nonce,
                            limit: limit,
                            offset: offset,
                            category: category,
                            page: page,
                        },
                        success: function(response) {
                            try {  
                                resolve(response.coins);
                                // console.log( response );
                            } catch (e) {
                                console.log('Error parsing response:', e);
                                reject(e);
                            }
                        },
                        error: function(xhr, status, error) {
                            console.log('AJAX call failed: ' + error);
                            reject(error);
                        }
                    });
                });
            }

            //Get search data via AJAX by PHP proxy function (in order to hide API key)    
            function ctpGetCoinsAjaxSearch(limit, page, search, category) {

                return new Promise((resolve, reject) => {

                    page  = parseInt(page);
                    limit = parseInt(limit);
            
            
                    let offset = (page - 1) * limit;
            
                    if (typeof ctpAjax === 'undefined' || typeof ctpAjax.ajax_url === 'undefined' || typeof ctpAjax.nonce === 'undefined') {
                        console.log('ctpAjax object or its properties are not defined.');
                        reject('ctpAjax object or its properties are not defined.');
                        return;
                    }
            
                    $.ajax({
                        url: ctpAjax.ajax_url,
                        type: 'POST',
                        data: {
                            action: 'ctp_ajax_search',
                            nonce: ctpAjax.nonce,
                            limit: limit,
                            offset: offset,
                            search: search,
                            category: category,
                            page: page,
                        },
                        success: function(response) {
                            try {  
                                resolve(response);
                            } catch (e) {
                                console.log('Error parsing response:', e);
                                reject(e);
                            }
                        },
                        error: function(xhr, status, error) {
                            console.log('AJAX call failed: ' + error);
                            reject(error);
                        }
                    });
                });
            }

            //Function add new rows to the empty table
            function ctpAddRows(container, numRows) {

                if( container && numRows ) {
                    let ctpCoinTable     = container.querySelector('.ctp-coin-table-body .ctp-coin-table-frame'); // rows holder
                    let ctpCoinTableRows = ctpCoinTable.querySelectorAll('.ctp-coin-table-row'); // array of rows 

                    for (let i = 0; i < numRows; i++) {

                        let newRow = document.createElement('div');
                        newRow.classList.add('ctp-coin-table-row');
                        newRow.dataset.coinId = "";

                        // html structure of a row
                        newRow.innerHTML = `
                        <div class="ctp-coin-rank ctp-line-skeleton"></div>
                        <div class="ctp-coin-name ctp-line-skeleton">
                            <div class="ctp-coin-icon"></div>                                
                            <span class="ctp-name-wrapper">
                                <span class="ctp-ct-name"></span>
                                <span class="ctp-ct-symbol"></span>
                            </span>   
                            <div class="ctp-coin-buy"></div>
                        </div>                        
                        <div class="ctp-coin-price ctp-line-skeleton"></div>
                        <div class="ctp-coin-last ctp-line-skeleton"></div>
                        <div class="ctp-coin-change ctp-line-skeleton">
                            <div class="ctp-trend-holder">
                                <span class="ctp-arrow-holder"></span>
                                <span class="ctp-coin-change-abs"></span> 
                            </div>                                                                                                             
                        </div>
                        <div class="ctp-coin-mc ctp-line-skeleton"></div>
                        <div class="ctp-coin-volume ctp-line-skeleton"></div>
                        <div class="ctp-coin-52-weeks ctp-line-skeleton">
                            <div class="ctp-low-high">
                                <span class="ctp-low"></span>
                                <span class="ctp-high"></span>
                            </div>
                            <div class="ctp-52-slider">
                                <div class="ctp-pink-slider"></div>
                                <div class="ctp-purple-slider"></div>
                            </div>
                        </div> 
                    `;
                
                        // Append the new row to the table
                        ctpCoinTable.appendChild(newRow);                
                    }
                    return null;            
                }       
            }     

            //Function to fill the table with data
            function ctpFillTable(container, limit, page, selectedFiatValue = '', category = '') {

                // fetching coins, initial filling table 
                let coinsArray;
                ctpGetCoinsAjax(limit, page, category)
                    .then(coins => {
                        coinsArray = coins;
                        ctpUpdateTable(container, coinsArray, limit, page);
                        updatePagination(page);  
                        ctpUpdatePrices( container, selectedFiatValue );  
                    })
                    .catch(error => {
                        console.error('Error fetching coins:', error);
                    });             
            }

            //Function to fill the table with searched data
            function ctpFillTableSearch(container, limit, page, search, selectedFiatValue = '', category = '') {

                // fetching coins, initial filling table 
                let coinsArray;
                ctpGetCoinsAjaxSearch(limit, page, search, category) 
                    .then(response => {
                        // console.log( response.total ); 

                        let totalCoins = parseInt(response.total);
                        let totalPages = Math.ceil(totalCoins/limit);  
                        let totalNav   = container.querySelector('.ctp-nav-total');

                        container.dataset.total   = totalPages;
                        container.dataset.coins   = totalCoins;
                        container.dataset.current = 1;
                        totalNav.textContent      = totalCoins;

                        coinsArray = response.coins;
                        ctpUpdateTable(container, coinsArray, limit, page);
                        updatePagination(page); 
                        ctpUpdatePrices( container, selectedFiatValue );  
                    })
                    .catch(error => {
                        console.error('Error fetching coins:', error);
                    }); 
            }

            //Function to get btc and eth     
            async function fetchBtcEth() {
                try {
                    let btcEth = await ctpGetCoinsAjax(5, 1);
                    let btc = '';
                    let eth = '';
                    
                    btcEth.forEach(coin => {
                        if (coin.symbol == 'BTC') {
                            btc = coin.price;
                        }
                        if (coin.symbol == 'ETH') {
                            eth = coin.price;
                        }
                    });
            
                    return { btc, eth };
                } catch (error) {
                    console.error('Error fetching coins:', error);
                    return null; 
                }
            }


            //Update prices in different fiat currency 
            function ctpUpdateFiatPrices(priceArray, selectedFiat, round = null) {

                const fiatUrl = 'https://open.er-api.com/v6/latest/USD';

                const formatFunctions = {
                    EUR: formatSmallPriceEuro,
                    GBP: formatSmallPricePound,
                    USD: formatSmallPriceDollar
                };

                fetch(fiatUrl)
                    .then(response => response.json())
                    .then(data => {
                        if (data.result) {
                            const conversionRate = data.rates[selectedFiat];
                            const formatFunction = formatFunctions[selectedFiat] || formatSmallPriceDollar;

                            if (conversionRate) {
                                // Loop through the price array and update prices based on the conversion rate
                                priceArray.forEach(priceElement => {
                                    const usdPrice = Number(priceElement.dataset.number);
                                    // console.log( typeof priceElement.dataset.number, priceElement.dataset.number );
                                    const convertedPrice = usdPrice * conversionRate;

                                    // rounding of mc and volume

                                    priceElement.textContent = formatFunction(convertedPrice);
                                   
                                });
                            } else {
                                console.error(`Conversion rate for ${selectedFiat} not available.`);
                            }
                        } else {
                            console.error('Error in the API response.');
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching the latest fiat prices:', error);
                    });
            }

            //Update prices in cryptocurrency
            function ctpUpdateCryptoPrices(priceArray, selectedCrypto, round = null) {

                // Fetch the latest BTC and ETH prices
                fetchBtcEth().then(prices => {
                    if (prices) {       

                        // Determine the selected crypto price
                        let selectedPrice;
                        if (selectedCrypto === 'BTC') {
                            selectedPrice = parseFloat(prices.btc);
                        } else if (selectedCrypto === 'ETH') {
                            selectedPrice = parseFloat(prices.eth);
                        }

                        // console.log( typeof selectedPrice, selectedPrice );

                        // Update the prices in the HTML elements
                        priceArray.forEach(priceElement => {
                            let usdPrice = parseFloat(priceElement.dataset.number);
                            usdPrice = parseFloat(usdPrice);
                            // console.log(usdPrice);                           
                            
                            let convertedPrice = formatSmallPriceCrypto(usdPrice / selectedPrice);  
                            priceElement.textContent = `${convertedPrice} ${selectedCrypto}`;

                           
                        });
                    }
                });
            }



            /**
             * Search field
             */
            let searchField      = container.querySelector('.ctp-search-field');
            let searchFieldValue = searchField.value;                        
            
            if( searchField ) {

                searchField.addEventListener('keyup', function(e) {                
                    let searchString = e.target.value;
                    let dataLimit    = container.dataset.limit;                     
                    if( searchString.length > 2 ) {
                        ctpFillTableSearch(container, dataLimit, 1, searchString, selectedFiatValue, dataCategory);
                    }     

                    if (searchString === '') {
                        console.log( container );
                        console.log( selectedFiatValue );
                        container.dataset.coins = container.dataset.all;
                        let newNumberPages      = Math.ceil(parseInt(container.dataset.all)/parseInt(container.dataset.limit));  
                        container.dataset.total = newNumberPages;
                        container.querySelector('.ctp-nav-total').textContent = container.dataset.all;
                     
                        ctpFillTable(container, dataLimit, 1, selectedFiatValue, dataCategory);                           
                    }
                });
            } 

            function insertBuyButtons(container) {

                let id = container.id;

                console.log( document.getElementById( containerId ) );

                let rows = container.querySelectorAll( '.ctp-coin-table-row' );

                if( rows.length > 0 ) {

                    rows.forEach(function(row) {                        
                        let buyButton = row.querySelector('.ctp-coin-buy');
                        let coinId    = buyButton.dataset.coinId;
                        console.log( row );
                        
                    });                     
                }
            }       

        });         
    } 
});





               




